export const API_URL = process.env.VUE_APP_API_URL
export const LEXON_PARTNER_ID = process.env.VUE_APP_LEXON_PARTNER_ID

export const LEXON_SALT = process.env.VUE_APP_SALT

export const AUTH_LEXON_TOKEN = 'AUTH-LEXON-TOKEN'
export const AUTH_LEXON_PARTNER_ID = 'LEXON-PARTNER-ID'
export const HEADER_REFRESH_TOKEN = 'X-Refresh-Token'
